// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2hFaF";
var _4 = "header-APBlV";
var _5 = "subheader-3b266";
var _6 = "content-3nWPz";
var _7 = "footer-16FtB";
var _8 = "switch__wrapper-1x-6l";
var _9 = "control__switch_root-347uf";
var _a = "vipServiceSelect__switch_label-3Va_8";
var _b = "segment-2clZJ";
var _c = "label-AuX22";
var _d = "control-MOtFu";
var _e = "control_selected-1UEbh";
var _f = "control_switch-JY3wi";
var _10 = "control_checkbox-vHcDd";
var _11 = "control_counter-1OoJa";
var _12 = "control__label-pPXJ8";
var _13 = "control__price-a0sZx";
var _14 = "counter__root-o3Mk0";
var _15 = "counter-F0LUj";
var _16 = "counter__value-3FSli";
var _17 = "checkbox-3ykya";
var _18 = "checkbox_checked-21nWM";
var _19 = "checkbox__root-1rIHI";
var _1a = "checkbox_label-3se_J";
var _1b = "passenger-1qb4y";
var _1c = "number-2ELSI";
var _1d = "direction-2J0Lc";
var _1e = "controls-3mP57";
var _1f = "cancel-2pLNk";
var _20 = "confirm-PErnB";
var _21 = "total-1dM9m";
var _22 = "price_from-1d6Xf";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "header", _5 as "subheader", _6 as "content", _7 as "footer", _8 as "switch__wrapper", _9 as "control__switch_root", _a as "vipServiceSelect__switch_label", _b as "segment", _c as "label", _d as "control", _e as "control_selected", _f as "control_switch", _10 as "control_checkbox", _11 as "control_counter", _12 as "control__label", _13 as "control__price", _14 as "counter__root", _15 as "counter", _16 as "counter__value", _17 as "checkbox", _18 as "checkbox_checked", _19 as "checkbox__root", _1a as "checkbox_label", _1b as "passenger", _1c as "number", _1d as "direction", _1e as "controls", _1f as "cancel", _20 as "confirm", _21 as "total", _22 as "price_from" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "header": _4, "subheader": _5, "content": _6, "footer": _7, "switch__wrapper": _8, "control__switch_root": _9, "vipServiceSelect__switch_label": _a, "segment": _b, "label": _c, "control": _d, "control_selected": _e, "control_switch": _f, "control_checkbox": _10, "control_counter": _11, "control__label": _12, "control__price": _13, "counter__root": _14, "counter": _15, "counter__value": _16, "checkbox": _17, "checkbox_checked": _18, "checkbox__root": _19, "checkbox_label": _1a, "passenger": _1b, "number": _1c, "direction": _1d, "controls": _1e, "cancel": _1f, "confirm": _20, "total": _21, "price_from": _22 }
